import React from 'react';
import HeroSection from '../components/HeroSection';
import DiscoverSection from '../components/DiscoverSection';
import CloudSolutionsSection from '../components/CloudSolutionsSection';
import DevOpsSection from '../components/DevOpsSection';
import TestimonialsSection from '../components/TestimonialsSection';

const Home = () => {
  return (
    <>
      <HeroSection />
      <DiscoverSection />
      <CloudSolutionsSection />
      <DevOpsSection />
      <TestimonialsSection />
    </>
  );
};

export default Home; 